
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { PageHeader } from 'Components/Public/PageHeader/PageHeader';
import { IconButton, IconTextButton } from 'Components/Button';
import { ICONS } from 'Utils/icons';
import { Badge, Button, Collapse, Form, ListGroup, Nav, OverlayTrigger, Tab, Tabs, Tooltip } from 'react-bootstrap';
import { useEffect, useRef, useState } from 'react';
import { http } from 'Utils';
import DetailCardSection from './DetailCardSection';
import DataElementCard from './DataElementCard';
import SearchBar from './SearchBar/SearchBar-Notmodal';
import { config } from 'Utils/config';
import { COMMON_FORMATS_COL_DOCS, COMMON_FORMATS_SUB_DOCS, ERROR_MESSAGES } from 'Utils/constants';
import CompareModal from './CompareModal';
import MobileDrawer from './MobileDrawer';
import { VER_MOD_DATA } from './RepoVerModDescrData';
import { useLocation, useSearchParams } from 'react-router-dom';
import { getResourceDownloadProps } from 'Utils/fileDownloadUtil';
import { setGlobalErrorStatus } from 'Components/StatusHandling';
import { useDispatch } from 'react-redux';
import { InstructionCard } from './InstructionCard';

import {ReactComponent as CompareBtnSVG} from '../../../Images/public/cf-repo/compare-btn.svg';

function Repository ({setCustomCrumb}) {
    const dispatch = useDispatch();
    const location = useLocation();

    // Breadcrumbs
    const [crumb, setCrumb] = useState(null);

    // URL Parameters
    const [params, setParams] = useSearchParams();
    const verId = params.get('v');
    const modId = params.get('m');

    // CF Versions
    const [comonFormatsList, setComonFormatsList] = useState(null);
    const [tabActiveKey, setTabActiveKey] = useState(26);
    const [activeVersion, setActiveVersion] = useState(null);

    // CF Versions - Dropdown
    const [isCFDropdownOpen, setIsCFDropdownOpen] = useState(false);
    const cfDropBtnRef = useRef(0)

    // Event Types
    const [eventTypeList, setEventTypeList] = useState(null);
    const [activeEventKey, setActiveEventKey] = useState(1);

    // Page Filters
    const [subOnly, setSubOnly] = useState(false);

    // Compare
    const [showCompareModal, setShowCompareModal] = useState(false);
    const [compareDe, setCompareDe] = useState(null);
    const [compareDeName, setCompareDeName] = useState(null);

    // Compare - Drawer
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [drawerData, setDrawerData] = useState(null);

    // Search
    const [searchTerm, setSearchTerm] = useState("");
    const [activeSearch, setActiveSearch] = useState(false);
    
    // Search - Highlights
    const [highlighted, setHighlighted] = useState({});

    // Search - Active Result
    const [focusDe, setFocusDe] = useState(null);
    const [resultIndex, setResultIndex] = useState(0);
    const [activeDrop, setActiveDrop] = useState(null);

    // Search - Results
    const resultsRef = useRef(null);
    const [resultCategories, setResultCategories] = useState([]);
    const [searchResultVersions, setSearchResultVersions] = useState([]);
    const [verResults, setVerResults] = useState([]);
    
    // Search - Count
    const [eventTypeCounts, setEventTypeCounts] = useState({});

    // Search - Intersection Observer
    const [isSticky, setIsSticky] = useState(false);
    const sentinelRef = useRef(null);
    const options = {
        root: null,
        threshold: [0,1], // Fires as soon as a single pixel crosses the boundary
        rootMargin: "0px",
    };

    // DE Cards
    const deRefs = useRef(new Map());
    const deAccRefs = useRef(new Map());
    const [groupDataList, setGroupDataList] = useState([]);
    const [expandedAccGroups, setExpandedAccGroups] = useState({});
    const [expandedGroups, setExpandedGroups] = useState({});


    // Check for specified version or module, if given, load those specific repo data and pages. If not, load standard initial data.
    useEffect(()=>{
        if(location?.state){
            var s = location.state;
            getRepoData(s.verId, s.modId);
        }
        else if(verId!=null){
            if(modId!=null){
                getRepoData(verId, modId);
            }
            else{
                getRepoData(verId);
            }
        }
        else{
            getRepoInitialLoadData();
        }
    },[])
    
    // Set custom breadcrumb
    useEffect(()=>{
        if(crumb!=null){
            setCustomCrumb(crumb);
        }
    }, [crumb])

    // Get split CF Version (version number and name)
    const getCFSplitName = (name) => {
        if(name!=null){
            const regex = /(?<name>[ A-Za-z]+) (?<version>V\d+\.\d+)/;     
            const result = name.match(regex);
            
            if(result!=null){
                return result.groups;
            }
        }
    } 

    // Get name of version with provided id from cfList
    const getCFName = (key, cfList)=>{ 
        config.isDebugEnabled && console.log("getCFName - key: " + key, cfList);
        return cfList.find((a) => a.id==key).name;
    }

    // Get name of event type with provided module id from eventList
    const getEventTypeName = (key, eventList)=>{ 
        config.isDebugEnabled && console.log("getEventName - key: " + key, eventList);
        return eventList.length>0 ? eventList.find((a) => a.moduleId==key).moduleLongName : "";
    }

    // Get version or module description from VER_MOD_DATA
    const getDescription = (versionId, moduleId)=>{ 
        config.isDebugEnabled && console.log(versionId,moduleId, VER_MOD_DATA);

        var data = VER_MOD_DATA.versionList[versionId];

        // If moduleId is not null, get module description
        if(moduleId!=null) {
            if((data.modules).hasOwnProperty(moduleId)){
                var mod = data.modules[moduleId];
                if (typeof mod.desc === 'function'){
                    return mod.desc();
                }
                else{
                    return mod.desc;
                }
            }
            else{
                return null;
            }
        }
        // If moduleId is null, get version description
        else{
            var ver = VER_MOD_DATA.versionList[versionId];
            if (typeof ver.desc === 'function'){
                return ver.desc();
            }
            else{
                return ver.desc;
            }
        }
    }

    // Get initial load CFRepo data
    const getRepoInitialLoadData = async () => {
        const call = async () => {
            var url = "/api/cfRepo/initLoad";
            return http.post(url, null);
        }
        return call().then((res) => {
            config.isDebugEnabled && console.log("getRepoInitialLoadData ", res);
            if (res.status != 1) {
                setGlobalErrorStatus({
                    dispatch: dispatch,
                    popupData: {
                        visible: true, 
                        title: ERROR_MESSAGES.GENERAL_ERROR.title, 
                        msg: res.globalErrorMessageList != null && res.globalErrorMessageList.length>0 ? res.globalErrorMessageList : ERROR_MESSAGES.GENERAL_ERROR.message, 
                        showContactHelp: false 
                    },
                    redirect: {
                        redirect: false, 
                        redirectFirst: false,
                        path: "", 
                        data: {}
                    }
                });
            }
            else {
                var info = res?.data;
                setExpandedGroups({});
                setComonFormatsList(info.versionList);
                setTabActiveKey(info.selectedVersion.id);
                setActiveEventKey(info.selectedModule.moduleId);
                setEventTypeList(info.moduleList);
                setExpandedAccGroups({});
                setGroupDataList(info.groupDataList);
                setActiveVersion(info.selectedVersion);
                setResultIndex(-1);
                setFocusDe(null);           
            }
            return res;
        }).catch((error)=>{
            setGlobalErrorStatus({
                dispatch: dispatch,
                popupData: {
                    visible: true, 
                    title: ERROR_MESSAGES.GENERAL_ERROR.title, 
                    msg: ERROR_MESSAGES.GENERAL_ERROR.message, 
                    showContactHelp: true 
                },
                redirect: {
                    redirect: false, 
                    redirectFirst: false,
                    path: "", 
                    data: {}
                }
            });
        });
    }

    const getRepoData = async (versionId, moduleId,focusDe) => {
        if(moduleId==null){
            moduleId=-1;
        }
        const call = async () => {
            var url = "/api/cfRepo/load";
            return http.post(url, {versionId: versionId, moduleId: moduleId});
        }
        return call().then((res) => {
            config.isDebugEnabled && console.log("getRepoData ", res);
            if (res.status != 1) {
                setGlobalErrorStatus({
                    dispatch: dispatch,
                    popupData: {
                        visible: true, 
                        title: ERROR_MESSAGES.GENERAL_ERROR.title, 
                        msg: res.globalErrorMessageList != null && res.globalErrorMessageList.length>0 ? res.globalErrorMessageList : ERROR_MESSAGES.GENERAL_ERROR.message, 
                        showContactHelp: false 
                    },
                    redirect: {
                        redirect: false, 
                        redirectFirst: false,
                        path: "", 
                        data: {}
                    }
                });
            }
            else {
                var info = res?.data;
                setExpandedGroups({});
                setComonFormatsList(info.versionList);
                setTabActiveKey(info.selectedVersion.id);
                setEventTypeList(info.moduleList);
                setExpandedAccGroups({});
                setGroupDataList(info.groupDataList);
                setActiveVersion(info.selectedVersion);
                setActiveEventKey(info.selectedModule.moduleId);
                
                if(focusDe!=null){
                    setExpandedGroups(prev=>({
                        ...prev,
                        [focusDe.deGroupId]: true
                    }))
                    setFocusDe(focusDe);
                }
                else{
                    setResultIndex(-1);
                    setFocusDe(null);
                }
            }
            return res;
        }).catch((error)=>{
            setGlobalErrorStatus({
                dispatch: dispatch,
                popupData: {
                    visible: true, 
                    title: ERROR_MESSAGES.GENERAL_ERROR.title, 
                    msg: ERROR_MESSAGES.GENERAL_ERROR.message, 
                    showContactHelp: true 
                },
                redirect: {
                    redirect: false, 
                    redirectFirst: false,
                    path: "", 
                    data: {}
                }
            });
        });
    }

    // Action to take when intersection change is triggered
    const callback = (entries, observer) => {
        entries.forEach((entry) => {
            var sticky = (!entry.isIntersecting) && entry.boundingClientRect.top < 0;
            if(sticky!=isSticky){
                setIsSticky((!entry.isIntersecting) && entry.boundingClientRect.top < 0);
            }
        });
    };
    
    // Observe sentinelRef intersection to trigger search feature stickiness
    useEffect(() => {
        if (!sentinelRef.current) {
            return;
        }
        const observer = new IntersectionObserver(callback,options);
        if (sentinelRef.current) {
            observer.observe(sentinelRef.current);
        }
    }, [sentinelRef,options]);


    // Set count of search results for each module in current version
    const setEventTypeSearchCount = (verResults) => {
        const eventTypeCounts = verResults.reduce((accumulator, currentItem) => {
            const type = currentItem.deModuleId;
            accumulator[type] = (accumulator[type] || 0) + 1;
            return accumulator;
        }, {});

        config.isDebugEnabled && console.log(verResults,eventTypeCounts);

        setEventTypeCounts(eventTypeCounts);
    }

    // Get search result count for module with id
    const getEventTypeCount = (modId) =>{
        if(eventTypeCounts!=null && eventTypeCounts.hasOwnProperty(modId)){
            return eventTypeCounts[modId];
        }
        else{
            return 0;
        }
    }

    // On version search results change, set search result counts
    useEffect(()=>{
        setEventTypeSearchCount(verResults);
    },[verResults])

    // Set search result versions list
    useEffect(()=>{
        if(resultCategories!=null){
            var resVersions = resultCategories.map((c) => {
                return c[1][0].deVersionId;
            })
            setSearchResultVersions(resVersions);
        }
        else{
            setSearchResultVersions([]);
        }
    },[resultCategories])

    return (
        <>
            {/* Compare DE Modal */}
            {
                
                comonFormatsList!=null && showCompareModal==true && compareDe!=null && compareDeName!=null
                ?
                    <CompareModal
                        setShowCompareModal={setShowCompareModal} 
                        showCompareModal={showCompareModal}
                        de_name={compareDeName}
                        de_id={compareDe}
                        commonFormatsList={
                            comonFormatsList
                        }
                        tabActiveKey={tabActiveKey}
                    >
                    </CompareModal> 
                :   null
            }

            <Row className="m-0 p-0">
                <PageHeader
                    title={<><span className="d-md-inline-block">Explore Common Formats</span> <span className="d-md-inline-block">Data Elements</span></>}
                    intro="Each version of the Common Formats contains one or more Event Descriptions, which describe the information collected by the PSOPPC for transmission to AHRQ's Network of Patient Safety Databases (NPSD). Use this repository to browse, search, and compare individual data elements across versions."
                    mainRowCols = {{
                        column: {
                            md: 10,
                            lg: 8,
                            xl: 7,
                            xxl: 6
                        }
                    }}
                >
                </PageHeader>

                {/* Compare/Detail Link Drawer */}
                <MobileDrawer
                    drawerOpen={drawerOpen}
                    setDrawerOpen={setDrawerOpen}
                    drawerData={drawerData}
                    setShowCompareModal={setShowCompareModal}
                    setCompareDe={setCompareDe}
                    setCompareDeName={setCompareDeName}
                    versionId={tabActiveKey}
                ></MobileDrawer>
                
                <Row lg={1} className="main-content repo-main mb-40px mb-lg-40px mt-0px mt-lg-0px gap-0px gap-lg-0px p-0 d-flex justify-content-center g-0 ">
                    {/* <Tabs
                        defaultActiveKey="mod"
                        id="compare-tab-example"
                        className=""
                        variant=""
                    >
                        <Tab eventKey="figma" title="Fig">
                            <Row className="content-instruction-section m-0 d-flex justify-content-center py-50px py-md-60px px-0px g-0">
                                <Col xxl={10} xl={11} lg={11} md={12} sm={12} className="d-flex flex-column text-start align-content-center gap-40px gap-md-30px px-3 px-lg-0">
                                    <h2 className="displayS bold mb-0 color-primary-navyblue ">Using the Repository</h2>
                                    <Row className="instruction-card-row gap-4 gap-md-0" xs={1} md={3} lg={3}>
                                        <InstructionCard
                                            icon={<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M3 13H5V11H3V13ZM3 17H5V15H3V17ZM3 9H5V7H3V9ZM7 13H21V11H7V13ZM7 17H21V15H7V17ZM7 7V9H21V7H7ZM3 13H5V11H3V13ZM3 17H5V15H3V17ZM3 9H5V7H3V9ZM7 13H21V11H7V13ZM7 17H21V15H7V17ZM7 7V9H21V7H7Z" fill="#193F64"/></svg>}
                                            title={"How it's organized"}
                                            body={"Elements are listed by Common Formats version, Event Type, and then grouped by the characteristics of the Data Element. Select a version tab to see what that version collects."}
                                        ></InstructionCard>
                                        <InstructionCard
                                            icon={<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M15.7559 14.2549H14.9659L14.6859 13.9849C15.6659 12.8449 16.2559 11.3649 16.2559 9.75488C16.2559 6.16488 13.3459 3.25488 9.75586 3.25488C6.16586 3.25488 3.25586 6.16488 3.25586 9.75488C3.25586 13.3449 6.16586 16.2549 9.75586 16.2549C11.3659 16.2549 12.8459 15.6649 13.9859 14.6849L14.2559 14.9649V15.7549L19.2559 20.7449L20.7459 19.2549L15.7559 14.2549ZM9.75586 14.2549C7.26586 14.2549 5.25586 12.2449 5.25586 9.75488C5.25586 7.26488 7.26586 5.25488 9.75586 5.25488C12.2459 5.25488 14.2559 7.26488 14.2559 9.75488C14.2559 12.2449 12.2459 14.2549 9.75586 14.2549Z" fill="#193F64"/></svg>}
                                            title={"Finding a Data Element"}
                                            body={"Search by ID, name, or description. Select an event type on the left to narrow the list. The number beside each event type is how many Data Elements it includes."}
                                        ></InstructionCard>
                                        <InstructionCard
                                            icon={<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M9.01 14H2V16H9.01V19L13 15L9.01 11V14ZM14.99 13V10H22V8H14.99V5L11 9L14.99 13Z" fill="#193F64"/></svg>}
                                            title={"Comparing versions"}
                                            body={<>Select <CompareBtnSVG></CompareBtnSVG> on any Hospital V1.2 or V2.0 Data Element to see how it changed between versions or whether it's still collected.</>}
                                        ></InstructionCard>
                                    </Row>
                                    
                                </Col>
                            </Row>
                        </Tab>
                        <Tab eventKey="mod" title="Mod"> */}
                            <Row className="content-instruction-section m-0 d-flex justify-content-center py-50px py-md-60px px-0px g-0">
                                <Col xxl={10} xl={11} lg={11} md={12} sm={12} className="d-flex flex-column text-start align-content-center gap-40px gap-md-30px px-3 px-lg-0">
                                    <h2 className="displayS bold mb-0 color-primary-navyblue text-center text-md-start">Using the Repository</h2>
                                    <Row className="instruction-card-row bottom gap-30px gap-md-0" xs={1} md={3} lg={3}>
                                        <InstructionCard
                                            icon={<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M3 13H5V11H3V13ZM3 17H5V15H3V17ZM3 9H5V7H3V9ZM7 13H21V11H7V13ZM7 17H21V15H7V17ZM7 7V9H21V7H7ZM3 13H5V11H3V13ZM3 17H5V15H3V17ZM3 9H5V7H3V9ZM7 13H21V11H7V13ZM7 17H21V15H7V17ZM7 7V9H21V7H7Z" fill="#193F64"/></svg>}
                                            title={"How it's organized"}
                                            body={"Elements are listed by Common Formats version, Event Type, and then grouped by the characteristics of the Data Element. Select a version tab to see what that version collects."}
                                        ></InstructionCard>
                                        <InstructionCard
                                            icon={<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M15.7559 14.2549H14.9659L14.6859 13.9849C15.6659 12.8449 16.2559 11.3649 16.2559 9.75488C16.2559 6.16488 13.3459 3.25488 9.75586 3.25488C6.16586 3.25488 3.25586 6.16488 3.25586 9.75488C3.25586 13.3449 6.16586 16.2549 9.75586 16.2549C11.3659 16.2549 12.8459 15.6649 13.9859 14.6849L14.2559 14.9649V15.7549L19.2559 20.7449L20.7459 19.2549L15.7559 14.2549ZM9.75586 14.2549C7.26586 14.2549 5.25586 12.2449 5.25586 9.75488C5.25586 7.26488 7.26586 5.25488 9.75586 5.25488C12.2459 5.25488 14.2559 7.26488 14.2559 9.75488C14.2559 12.2449 12.2459 14.2549 9.75586 14.2549Z" fill="#193F64"/></svg>}
                                            title={"Finding a Data Element"}
                                            body={"Search by ID, name, or description. Select an event type on the left to narrow the list. The number beside each event type is how many Data Elements it includes."}
                                        ></InstructionCard>
                                        <InstructionCard
                                            icon={<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M9.01 14H2V16H9.01V19L13 15L9.01 11V14ZM14.99 13V10H22V8H14.99V5L11 9L14.99 13Z" fill="#193F64"/></svg>}
                                            title={"Comparing versions"}
                                            body={<>Select <CompareBtnSVG></CompareBtnSVG> on any Hospital V1.2 or V2.0 Data Element to see how it changed between versions or whether it's still collected.</>}
                                        ></InstructionCard>
                                    </Row>
                                </Col>
                            </Row>
                        {/* </Tab>
                    </Tabs> */}
                    
                    <Col id="repository-main-content" xs={12} lg={12} className="repository-main-content px-3 px-lg-40px flex-shrink-1 gap-4 g-0 bg-color-base-offwhite">
                        <Col xs={12} lg={12}  className="text-start pt-0  p-0 flex-shrink-1 content-container">
                            <div className="search-container d-flex flex-column gap-2 pt-40px pt-lg-60px" >
                                <div className="header4 bold mb-0 color-primary-navyblue">Search Data Elements</div>

                                {/* Search Feature Component (Observed by intersection observer) */}
                                <Col className={"d-flex flex-column flex-lg-row justify-content-between gap-4 flex-wrap"} ref={sentinelRef}>
                                    <Col sm={12} md={12} lg={7} id="floating-search" className={"p-0 flex-grow-1 flex-shrink-1"} >
                                        <div className="p-0">
                                            <SearchBar
                                                activeDrop={activeDrop}
                                                setActiveDrop={setActiveDrop}
                                                highlighted={highlighted}
                                                setHighlighted={setHighlighted}
                                                categoryId={tabActiveKey}
                                                moduleKey={activeEventKey}
                                                setModuleKey={setActiveEventKey}
                                                handleChange={getRepoData}
                                                comonFormatsList={comonFormatsList}
                                                setFocusKeyword={setFocusDe}
                                                setActiveSearch={setActiveSearch}
                                                activeSearch={activeSearch}
                                                searchTerm={searchTerm}
                                                setSearchTerm={setSearchTerm}
                                                isSticky={isSticky}
                                                resultCategories={resultCategories}
                                                setResultCategories={setResultCategories}
                                                resultIndex={resultIndex}
                                                setResultIndex={setResultIndex}
                                                subOnly={subOnly}
                                                setSubOnly={setSubOnly}
                                                resultsRef={resultsRef}
                                                verResults={verResults}
                                                setVerResults={setVerResults}
                                            ></SearchBar>
                                        </div>
                                    </Col>

                                    {/* Toggle Input for PSOPPC Submit Only */}
                                    <Form className="d-flex flex-shrink-0">
                                        <Form.Group className="d-flex flex-row align-items-start g-0 gap-2 pt-0 pt-lg-2" controlId="psoppcSubmit" >
                                            <Form.Check 
                                                type="switch"
                                                id={"psoppc-only-submit"}
                                                label={"Can submit to PSOPPC only"}
                                                className="mb-0 d-flex flex-row align-items-center gap-2"
                                                onChange={(e)=>{
                                                    setSubOnly(e.target.checked);
                                                }}
                                                checked={subOnly}
                                            />
                                                <OverlayTrigger
                                                    placement={'left'}
                                                    overlay={
                                                        <Tooltip  id="psoppcOnlyDesc" className="bodyS regular public-tooltip-light text-start">
                                                            Data Elements with a red asterisk (<span className="color-error-red">*</span>) are not accepted for data submission by PSOPPC
                                                        </Tooltip>
                                                    }
                                                >
                                                    <IconButton className="tooltip-btn-trigger" hiddenText="Can submit to PSOPPC only" variant="comp-plain" icon={ICONS.repoInfoTooltipTrigger}></IconButton>
                                                </OverlayTrigger>
                                        </Form.Group>
                                    </Form>
                                </Col>
                            </div>
                                
                            {
                                comonFormatsList != null && eventTypeList!=null && tabActiveKey!=null
                                ?
                                    <>
                                        <Tab.Container
                                            id="repo-tabs"
                                            activeKey={tabActiveKey}
                                            defaultActiveKey={0}
                                            mountOnEnter={true}
                                            unmountOnExit={true}
                                            variant="repo"
                                        >
                                            <div className="my-0 bg-color-base-white w-100 repo-tab-container position-relative">
                                                {/* MOBILE - Version selection dropdown button */}
                                                <Button
                                                    className={"d-flex d-lg-none body bold" + (searchResultVersions!=null && searchResultVersions.includes(tabActiveKey) ? " has-results" : "")}
                                                    onClick={() => setIsCFDropdownOpen(!isCFDropdownOpen)}
                                                    aria-controls="repo-drop-menu"
                                                    aria-expanded={isCFDropdownOpen}
                                                    variant="repo-drop"
                                                    ref={cfDropBtnRef}
                                                >
                                                    <div className={"cfname"}>{getCFName(tabActiveKey, comonFormatsList)}</div>
                                                    <svg className={isCFDropdownOpen==false ? "down-icon" : 'up-icon'} xmlns="http://www.w3.org/2000/svg" width="12" height="8" viewBox="0 0 12 8" fill="none">
                                                        <path d="M1.41 7.41L6 2.83L10.59 7.41L12 6L6 3.8147e-06L0 6L1.41 7.41Z" fill="#1D6193"/>
                                                    </svg>
                                                </Button>
                                                {/* Version selection button list. Always visible on desktop. On mobile visibility is toggled by Dropdown Button */}
                                                <Collapse id="repo-drop-menu" in={isCFDropdownOpen} appear={false} timeout={0} className="d-lg-block repo-drop-menu ">
                                                    <div>
                                                        {/* CF Version Navigation */}
                                                        <Nav
                                                            id="repo-tabs"
                                                            onSelect={(k) => {
                                                                setActiveDrop(null);
                                                                getRepoData(k,null,null);
                                                                setIsCFDropdownOpen(false);
                                                                (cfDropBtnRef.current).focus();
                                                            }}
                                                            variant="repo"
                                                        >
                                                            <>
                                                                {
                                                                    comonFormatsList != null
                                                                    ?
                                                                        // Add version buttons
                                                                        comonFormatsList.map((cat, index) => {
                                                                            if(cat.isActive==1){
                                                                                var {name, version} = getCFSplitName(cat.name);
                                                                                return (
                                                                                    <Nav.Item key={cat.id}>
                                                                                        <Nav.Link className={(searchResultVersions!=null && searchResultVersions.includes(cat.id) ? " has-results" : "")} eventKey={cat.id} as={"button"}  role={"navigation"} disabled={cat.id == tabActiveKey ? "disabled" : ""}>
                                                                                            <div className="d-none d-lg-flex flex-column align-items-center">
                                                                                                <div className="d-flex flex-row position-absolute align-items-center">
                                                                                                    <span className="tab-name">{name}</span>
                                                                                                    <Badge bg="version">{version}</Badge>
                                                                                                </div>
                                                                                                <div aria-hidden="true" className=" hide d-flex flex-row align-items-center">
                                                                                                    <span className="bold-sizer" >{name}</span>
                                                                                                    <Badge className="hide-ver" bg="version">{version}</Badge>
                                                                                                </div>
                                                                                            </div>
                                                                                            <div className="d-flex d-lg-none flex-row justify-content-between w-100 version-mobile">
                                                                                                <div className={"d-flex flex-row position-relative align-items-center gap-2 "+ (searchResultVersions!=null && searchResultVersions.includes(cat.id) ? " has-results" : "")}>
                                                                                                    <span className={"tab-name" }>{cat.name}</span>
                                                                                                </div>
                                                                                                {/* <div className="d-flex flex-row position-relative">
                                                                                                    <span className="tab-name">{cat.name}</span>
                                                                                                </div> */}
                                                                                            </div>
                                                                                        </Nav.Link>
                                                                                    </Nav.Item>
                                                                                );
                                                                            }
                                                                        })
                                                                    :   null
                                                                }
                                                                
                                                            </>
                                                        </Nav>
                                                    </div>
                                                </Collapse>
                                            </div>
                                           
                                            <Col xs={12} lg={12}  className="event-types d-flex flex-column text-start align-content-start gap-2 gap-lg-4 pt-lg-60px ">
                                                <div className="header4 bold mb-0 color-primary-navyblue">Event Types</div>
                                                <div className="scroll-border">
                                                    <div className="repo-event-selection-scroll-container">

                                                        {/* Event Type Navigation Buttons */}
                                                        <ListGroup role="event-types" variant="other" className="bg-color-base-white p-0 event-type-selection gap-2" >
                                                            {
                                                                eventTypeList.map((mod, index) => {
                                                                    return(
                                                                        <ListGroup.Item 
                                                                            onClick={()=>{
                                                                                setActiveDrop(null);
                                                                                getRepoData(tabActiveKey,mod.moduleId, null);
                                                                            }}
                                                                            action
                                                                            eventKey={mod.moduleId} 
                                                                            active={activeEventKey == mod.moduleId} 
                                                                            disabled={activeEventKey == mod.moduleId ? "disabled" : ""} 
                                                                            key={"module-"+mod.moduleId}
                                                                            role="list"
                                                                        >
                                                                            <div 
                                                                                className={
                                                                                    activeEventKey == mod.moduleId 
                                                                                    ?   "position-absolute event-type-choice d-flex flex-row body semibold align-items-center justify-content-between w-100" 
                                                                                    :   "position-absolute w-100 event-type-choice d-flex body flex-row regular align-items-center justify-content-between"
                                                                                }
                                                                            >
                                                                                <div className="mod-name">{mod.moduleName}</div>
                                                                                <div className={"d-flex flex-row gap-1" + (getEventTypeCount(mod.moduleId)>0 ? " has-results" : "")}>
                                                                                    {/* {
                                                                                        getEventTypeCount(mod.moduleId)>0 
                                                                                        ?  <Badge bg="warning" className={activeEventKey == mod.moduleId ? "bodyS semibold" : "bodyS regular "}>
                                                                                                {getEventTypeCount(mod.moduleId) + " Results"}
                                                                                            </Badge>
                                                                                        : null
                                                                                    } */}
                                                                                    <Badge bg="event-count" className={activeEventKey == mod.moduleId ? "bodyS semibold" : "bodyS regular"}>
                                                                                        {mod.moduleDeCount}
                                                                                    </Badge>
                                                                                </div>
                                                                            </div>

                                                                            {/* HIDDEN - Used to provide correct amount of space for bolded text to prevent shifting on hover */}
                                                                            <div aria-hidden="true" className={"hide event-type-choice d-flex flex-row body semibold align-items-center justify-content-between"}>
                                                                                <div>{mod.moduleName}</div> 
                                                                                <div className={"d-flex flex-row gap-1" + (getEventTypeCount(mod.moduleId)>0 ? " has-results" : "")}>
                                                                                    {/* {
                                                                                        getEventTypeCount(mod.moduleId)>0 
                                                                                        ?  <Badge bg="warning" className={"bodyS semibold"}>{getEventTypeCount(mod.moduleId) + " Results"}</Badge>
                                                                                        : null
                                                                                    } */}
                                                                                    <Badge bg="event-count" className={"bodyS semibold"}>{mod.moduleDeCount}</Badge>
                                                                                </div>
                                                                            </div>
                                                                        </ListGroup.Item>
                                                                    );
                                                                })
                                                            }
                                                        </ListGroup>
                                                    </div>
                                                </div>
                                                
                                                {/* DESKTOP - Download Submission and Collection Buttons */}
                                                <div className="impl-doc-btn-container d-none d-lg-flex flex-column gap-2">
                                                    <IconTextButton {...getResourceDownloadProps(COMMON_FORMATS_COL_DOCS[tabActiveKey])} size="lg" className="d-flex reverse text-center justify-content-center justify-content-lg-start w-xs-100 w-lg-fit-content px-3" content="Data Collection Resources" variant="comp-clear" icon={ICONS.download}></IconTextButton>
                                                    <IconTextButton {...getResourceDownloadProps(COMMON_FORMATS_SUB_DOCS[tabActiveKey])} size="lg" className="d-flex reverse text-center justify-content-center justify-content-lg-start w-xs-100 w-lg-fit-content px-3" content="Data Submission Resources" variant="comp-clear" icon={ICONS.download}></IconTextButton>
                                                </div>
                                            </Col>

                                            {/* MOBILE - Download Submission and Collection Buttons */}
                                            <div className="impl-doc-btn-container d-flex d-lg-none flex-column gap-2">
                                                <IconTextButton {...getResourceDownloadProps(COMMON_FORMATS_COL_DOCS[tabActiveKey])} size="lg" className="d-flex reverse text-center justify-content-center justify-content-lg-start w-xs-100 w-lg-fit-content px-3" content="Data Collection Resources" variant="comp-clear" icon={ICONS.download}></IconTextButton>
                                                <IconTextButton {...getResourceDownloadProps(COMMON_FORMATS_SUB_DOCS[tabActiveKey])} size="lg" className="d-flex reverse text-center justify-content-center justify-content-lg-start w-xs-100 w-lg-fit-content px-3" content="Data Submission Resources" variant="comp-clear" icon={ICONS.download}></IconTextButton>
                                            </div>
                                            
                                            <Tab.Content className="main-tab-content d-grid">
                                                <Tab.Pane eventKey={tabActiveKey} className="d-flex flex-column gap-4 gap-lg-40px">

                                                    {/* Version and Module Description Accordions */}
                                                    <DetailCardSection 
                                                        key={"detail-card-section-el-"+tabActiveKey}
                                                        setShowCompareModal={setShowCompareModal} 
                                                        detailCardsData={
                                                            [
                                                                {
                                                                    key:    1,
                                                                    header: getCFName(tabActiveKey, comonFormatsList),
                                                                    desc:  getDescription(tabActiveKey, null)
                                                                },
                                                                {
                                                                    key:    2,
                                                                    header: getEventTypeName(activeEventKey, eventTypeList),
                                                                    desc:   getDescription(tabActiveKey, activeEventKey)
                                                                }
                                                            ]
                                                        }
                                                        setCompareDe={setCompareDe}
                                                        setCompareDeName={setCompareDeName}
                                                        tabActiveKey={tabActiveKey}
                                                        activeEventKey={activeEventKey}
                                                    ></DetailCardSection>
                                                    
                                                    {/* Data Element Group Cards */}
                                                    <div className="data-element-cards-container">
                                                        {
                                                            groupDataList.map((group)=>{
                                                                //console.log(group);
                                                                return(
                                                                    <DataElementCard 
                                                                        key={"de-card-el-" + group.groupId}
                                                                        expandedAccGroups={expandedAccGroups} 
                                                                        setExpandedAccGroups={setExpandedAccGroups} 
                                                                        expandedGroups={expandedGroups} 
                                                                        setExpandedGroups={setExpandedGroups} 
                                                                        focusDe={focusDe} 
                                                                        deRefs={deRefs} 
                                                                        deAccRefs={deAccRefs} 
                                                                        activeVersion={activeVersion} 
                                                                        setDrawerData={setDrawerData} 
                                                                        setDrawerOpen={setDrawerOpen} 
                                                                        setShowCompareModal={setShowCompareModal} 
                                                                        deCardData={
                                                                            {
                                                                                order: group.groupId,
                                                                                title: group.groupName,
                                                                                titleDesc: group.groupDesc,
                                                                                dataElements: group.groupDeList
                                                                                
                                                                            }
                                                                        }
                                                                        setCompareDe={setCompareDe}
                                                                        setCompareDeName={setCompareDeName}
                                                                        subOnly={subOnly}
                                                                        resultCategories={resultCategories}
                                                                        tabActiveKey={tabActiveKey}
                                                                        activeEventKey={activeEventKey}
                                                                    ></DataElementCard>
                                                                )
                                                            })
                                                        }
                                                    </div>
                                                </Tab.Pane>
                                            </Tab.Content>
                                        </Tab.Container>
                                    </>
                                :   null
                            }
                        </Col>
                    </Col>
                </Row>
            </Row>
        </>
    );
}

export default Repository;
